export const findMatchingPropertyName = (obj, str) => {
    // The function returns the object's property name that matches with the string
    const props = Object.keys(obj);
    for (let i = 0; i < props.length; i++) {
        const prop = props[i];
        if (obj[prop] === str) return prop;
    }
}

export const isArrayOrObject = (obj) => {
	if (typeof obj === 'object') {
		if (obj.length >= 0) return 'array';
		else return 'object';
	} else return 'different_type';
}

// Good for smaller objects 
export const deepCopyJSON = obj => JSON.parse(JSON.stringify(obj));

// Good for bigger objects
export const deepCopy = (obj) => {
	// First do a shalow copying
	let newObj = {};
	if (isArrayOrObject(obj) === 'object') newObj = Object.assign({}, obj);
	else if (isArrayOrObject(obj) === 'array') newObj = Array.from(obj);
    
	// Test if there is a need for deep copying of the object
    const props = Object.keys(obj);
    for (let i = 0; i < props.length; i++) {
        const prop = props[i];
		// If property is an object
        if (typeof obj[prop] === 'object') newObj[prop] = deepCopy(obj[prop]);
    }
	
	return newObj;
}


// Check if properties match
export const doPropertiesMatch = (targetObj, queryObj) => {
    const queryProps = Object.keys(queryObj);
    const targertProps = Object.keys(targetObj);
    
    let count = 0;
    queryProps.forEach(queryProp => {
        targertProps.forEach(targertProp => {
            if (targertProp === queryProp) count++;
        });
    });
    return (count === queryProps.length);
}


// find multiple rows where properties match
// The function receives an array of objects and query object
// then checks if the properties of each object in the array 
// match with that of the query object

export const findAllWhere = (rows, queryObj) => {
    if (doPropertiesMatch(rows[0], queryObj)) {
        const queryProps = Object.keys(queryObj);
        const matchRows = [];
        
        for (let i = 0; i < rows.length; i++) {
            let count = 0;
            for (let j = 0; j < queryProps.length; j++) {
                const prop = queryProps[j];
                if (rows[i][prop] === queryObj[prop]) count++;
                else break;
            }
            if (count === queryProps.length) matchRows.push(rows[i]);
        }
        if (!matchRows && !matchRows.length) throw "No matching records found";
        else return matchRows;
    } else throw "Incorrect Query Properties";
}

// The function works like the findAllWhere function 
// but only returns one matching row
export const findOneWhere = (rows, queryObj) => {
    if (doPropertiesMatch(rows[0], queryObj)) {
        const queryProps = Object.keys(queryObj);
        
        for (let i = 0; i < rows.length; i++) {
            let count = 0;
            for (let j = 0; j < queryProps.length; j++) {
                const prop = queryProps[j];
                if (rows[i][prop] === queryObj[prop]) count++;
                else break;
            }
            if (count === queryProps.length) return rows[i];
        }
        throw "Record not found";
    } else throw "Incorrect Query Properties";
}
